import { customAlphabet } from 'nanoid';
const alphabet = '23456789ABCDEFGHJKMNPQRSTUVWXYZ';
const generateId = customAlphabet(alphabet, 8);
export const ENTITY_PREFIXES = {
    USER: 'USER',
    PROPERTY: 'PROP',
    PORTFOLIO: 'PORT',
    FILE: 'FILE',
    INCOME_SCHEDULE: 'INCS',
    EXPENSE_SCHEDULE: 'EXPS',
    OWNERSHIP: 'OWND',
    BANK: 'BANK',
    UNIT: 'UNIT',
    NOTIFICATION: 'NOTF',
    DOCUMENT: 'DOCM',
    DOCUMENT_CATEGORIZATION: 'DCAT',
    CONTRACT: 'CNTR',
    CONTRACT_STATUS: 'CNTS',
    CONTRACT_NOTE: 'CNTN',
    CONTRACT_RESPONSE: 'CNTE',
    CONTRACT_AI_SUMMARY: 'CNTA',
    INVOICE: 'INVC',
    INVOICE_STATUS: 'INVS',
    RFP_TEMPLATE: 'RFPT',
    TIMELINE_EVENT: 'TEVT',
    DASHBOARD_WIDGET: 'DWGT',
    BUDGET: 'BUDG',
    INCOME_PAYMENT_OCCURRENCE: 'IPMO',
    PAYABLI_PAYMENT: 'PYBL',
    UNRESOLVED_PAYABLI_WEBHOOK: 'UPWH',
    BOARD_ROSTER: 'BRST',
    BOARD_ROSTER_MEMBER: 'BRMB',
    RFP: 'RFPR',
    RFP_COLLECTION_STATUS: 'RFPC',
    RFP_PUBLICATION: 'RFPP',
    VENDOR: 'VEND',
    INVOICE_VENDOR_ALIAS: 'VALS',
    PROPOSAL: 'PRPS',
    PROPOSAL_VERSION: 'PRPV',
    PROPOSAL_VERSION_STATUS: 'PRVS',
    PROPOSAL_ANALYSIS_RUN: 'PARN',
    PROPOSAL_ANALYSIS_RUN_STATUS: 'PARS',
    COMPARISON_SESSION: 'CMPS',
    RFP_PROPOSAL_REVIEW: 'RREV',
    RFP_PROPOSAL_REVIEW_EVENT: 'RRVE',
    AGENT_TASK_OUTPUT: 'ATSK',
    PAYMENT_ATTEMPT: 'PATT',
    UNIT_PARTY: 'UPTY',
    LEASE: 'LEAS',
    INVOICE_DISPUTE: 'DISP',
    INVOICE_DISPUTE_EVENT: 'DSPE',
    RENT_INCREASE_NOTICE: 'RNOT',
    DOCUMENT_DISTRIBUTION: 'DDIS',
    BUDGET_PLAN: 'BPLN',
    BUDGET_PLAN_PROPOSAL: 'BPRP',
    LOAN: 'LOAN',
    LOAN_SCHEDULE_VERSION: 'LSVR',
    LOAN_LIFECYCLE_EVENT: 'LNEV',
    AR_INVOICE_SEND_RUN: 'ASND',
    AR_PRINT_SHOP_SEND: 'APSS',
    AI_PROPOSAL: 'AIPR',
    AP_INBOX: 'APIN',
    AP_INBOUND_EMAIL: 'APEM',
};
const generateDisplayId = (prefix) => {
    return `${prefix}${generateId()}`;
};
export const __private = {
    generateDisplayId,
    alphabet,
};
export const generateUserDisplayId = () => generateDisplayId(ENTITY_PREFIXES.USER);
export const generatePropertyDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPERTY);
export const generatePortfolioDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PORTFOLIO);
export const generateFileDisplayId = () => generateDisplayId(ENTITY_PREFIXES.FILE);
export const generateOwnershipProfileDisplayId = () => generateDisplayId(ENTITY_PREFIXES.OWNERSHIP);
export const generateBankAccountDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BANK);
export const generateUnitDisplayId = () => generateDisplayId(ENTITY_PREFIXES.UNIT);
export const generateUnitPartyDisplayId = () => generateDisplayId(ENTITY_PREFIXES.UNIT_PARTY);
export const generateLeaseDisplayId = () => generateDisplayId(ENTITY_PREFIXES.LEASE);
export const generateNotificationDisplayId = () => generateDisplayId(ENTITY_PREFIXES.NOTIFICATION);
export const generateDocumentDisplayId = () => generateDisplayId(ENTITY_PREFIXES.DOCUMENT);
export const generateDocumentCategorizationDisplayId = () => generateDisplayId(ENTITY_PREFIXES.DOCUMENT_CATEGORIZATION);
export const generateContractDisplayId = () => generateDisplayId(ENTITY_PREFIXES.CONTRACT);
export const generateContractStatusDisplayId = () => generateDisplayId(ENTITY_PREFIXES.CONTRACT_STATUS);
export const generateContractNoteDisplayId = () => generateDisplayId(ENTITY_PREFIXES.CONTRACT_NOTE);
export const generateContractResponseDisplayId = () => generateDisplayId(ENTITY_PREFIXES.CONTRACT_RESPONSE);
export const generateContractAiSummaryDisplayId = () => generateDisplayId(ENTITY_PREFIXES.CONTRACT_AI_SUMMARY);
export const generateIncomeScheduleDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INCOME_SCHEDULE);
export const generateExpenseScheduleDisplayId = () => generateDisplayId(ENTITY_PREFIXES.EXPENSE_SCHEDULE);
export const generateInvoiceDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INVOICE);
export const generateInvoiceStatusDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INVOICE_STATUS);
export const generateApInboxDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AP_INBOX);
export const generateApInboundEmailDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AP_INBOUND_EMAIL);
export const generateRfpTemplateDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP_TEMPLATE);
export const generateCalendarEventDisplayId = () => generateDisplayId(ENTITY_PREFIXES.TIMELINE_EVENT);
export const generateDashboardWidgetDisplayId = () => generateDisplayId(ENTITY_PREFIXES.DASHBOARD_WIDGET);
export const generateBudgetDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BUDGET);
export const generateBudgetPlanDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BUDGET_PLAN);
export const generateBudgetPlanProposalDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BUDGET_PLAN_PROPOSAL);
export const generateIncomePaymentOccurrenceDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INCOME_PAYMENT_OCCURRENCE);
export const generatePayabliPaymentDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PAYABLI_PAYMENT);
export const generateUnresolvedPayabliWebhookDisplayId = () => generateDisplayId(ENTITY_PREFIXES.UNRESOLVED_PAYABLI_WEBHOOK);
export const generateBoardRosterDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BOARD_ROSTER);
export const generateBoardRosterMemberDisplayId = () => generateDisplayId(ENTITY_PREFIXES.BOARD_ROSTER_MEMBER);
export const generateRfpDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP);
export const generateRfpCollectionStatusDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP_COLLECTION_STATUS);
export const generateRfpPublicationDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP_PUBLICATION);
export const generateVendorDisplayId = () => generateDisplayId(ENTITY_PREFIXES.VENDOR);
export const generateProposalDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPOSAL);
export const generateProposalVersionDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPOSAL_VERSION);
export const generateProposalVersionStatusDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPOSAL_VERSION_STATUS);
export const generateProposalAnalysisRunDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPOSAL_ANALYSIS_RUN);
export const generateProposalAnalysisRunStatusDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PROPOSAL_ANALYSIS_RUN_STATUS);
export const generateComparisonSessionDisplayId = () => generateDisplayId(ENTITY_PREFIXES.COMPARISON_SESSION);
export const generateRfpProposalReviewDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP_PROPOSAL_REVIEW);
export const generateRfpProposalReviewEventDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RFP_PROPOSAL_REVIEW_EVENT);
export const generateAgentTaskOutputDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AGENT_TASK_OUTPUT);
export const generatePaymentAttemptDisplayId = () => generateDisplayId(ENTITY_PREFIXES.PAYMENT_ATTEMPT);
export const generateInvoiceDisputeDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INVOICE_DISPUTE);
export const generateInvoiceDisputeEventDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INVOICE_DISPUTE_EVENT);
export const generateRentIncreaseNoticeDisplayId = () => generateDisplayId(ENTITY_PREFIXES.RENT_INCREASE_NOTICE);
export const generateDocumentDistributionDisplayId = () => generateDisplayId(ENTITY_PREFIXES.DOCUMENT_DISTRIBUTION);
export const generateLoanDisplayId = () => generateDisplayId(ENTITY_PREFIXES.LOAN);
export const generateLoanScheduleVersionDisplayId = () => generateDisplayId(ENTITY_PREFIXES.LOAN_SCHEDULE_VERSION);
export const generateLoanLifecycleEventDisplayId = () => generateDisplayId(ENTITY_PREFIXES.LOAN_LIFECYCLE_EVENT);
export const generateArInvoiceSendRunDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AR_INVOICE_SEND_RUN);
export const generateArPrintShopSendDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AR_PRINT_SHOP_SEND);
export const generateAiProposalDisplayId = () => generateDisplayId(ENTITY_PREFIXES.AI_PROPOSAL);
export const getEntityTypeFromDisplayId = (displayId) => {
    const prefixes = Object.values(ENTITY_PREFIXES);
    const prefix = prefixes.find((p) => displayId.startsWith(p));
    return prefix || null;
};
export const isValidDisplayId = (displayId) => {
    return getEntityTypeFromDisplayId(displayId) !== null && displayId.length === 12;
};
export const generateInvoiceVendorAliasDisplayId = () => generateDisplayId(ENTITY_PREFIXES.INVOICE_VENDOR_ALIAS);
//# sourceMappingURL=displayId.js.map